import { render } from "./SettingsView.vue?vue&type=template&id=4e429413&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=4e429413&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e429413"]])

export default __exports__